/**
 * public 目录静态资源 URL。
 * 文件名在替换后通常不变，nginx/浏览器会按路径长期缓存；
 * 通过构建时写入的版本号破坏缓存。
 */
function publicBase() {
  const base = process.env.BASE_URL || "/";
  return base.endsWith("/") ? base : `${base}/`;
}

export function withAssetVersion(url) {
  if (!url) return url;
  const version = process.env.VUE_APP_ASSET_VERSION;
  if (!version) return url;
  const join = url.includes("?") ? "&" : "?";
  return `${url}${join}v=${encodeURIComponent(version)}`;
}

export function publicAssetUrl(relativePath) {
  const path = String(relativePath || "").replace(/^\//, "");
  return withAssetVersion(`${publicBase()}${path}`);
}

export function sliceAssetUrl(dir, name) {
  return publicAssetUrl(`${dir}/${encodeURIComponent(name)}`);
}
